export default "__VITE_ASSET__C1Kxzoo3__"